<template>
  <div>
    <h5 class="card-title">商品黑名单</h5>
    <h6 class="card-subtitle text-muted">发票中的商品包含以下关键字，将不允许报销</h6><hr>
    <form>

      <div class="form-group">
        <label for="exampleFormControlTextarea1">如有多个条件以逗号分隔</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="10" 
          placeholder="例如：茅台, 中华" v-model="prodBlacklistDto.keywords"></textarea>
      </div>
      <button type="submit" class="btn btn-primary" @click="save">保存</button>

    </form>

  </div>
</template>

<script>
import * as prodblacklistFacade from "../../../api/prodblacklist-facade.js";

export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      prodBlacklistDto:{}
    };
  },

  created() {
    this.getProdblacklistInfo(this.orgId)
  },
  mounted() {},
  methods: {
    getProdblacklistInfo(orgId){
      this.pageLoading = true;
      prodblacklistFacade
        .obtain(orgId)
        .then(res => {
          this.pageLoading = false;
          this.prodBlacklistDto = res;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

    save(){
      prodblacklistFacade
        .save(this.prodBlacklistDto)
        .then(()=>{
          this.$message({
            message: "黑名单设置成功",
            type: "success"
          });
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
  }
};
</script>

<style >
</style>
